module.exports = function getResource(label, vars = []) {
    let resources = {
        ends: `Prend fin ${vars[0]}`,
        pointMultiplier: 'Événement multiplication des points',
        apply: 'Appliquer la promo',
        remove: 'Supprimer',
        applied: 'Appliqué',
        details: 'Détails',
        perDollar: 'Par dollar',
        pointMultiplierEventTitle: 'Événement multiplication des points',
        gotIt: 'Compris'
    };
    return resources[label];
};
